import { en } from "assets/locales"

export const LOCALE = {
  EN: "EN"
};

export const LOCALE_STRINGS = {
  [LOCALE.EN]: en
};

export const DATE_FORMAT = {
  DEFAULT: {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  } as any,
  YEAR_MONTH: {
    year: "numeric",
    month: "short",
  }
}

export const TIME_FORMAT = {
  DEFAULT: {
    hour: "2-digit",
    minute: "2-digit",
  } as any
}

export const INPUT_MASK = {
  DATE: "9999-99-99",
  PHONE: "(999) 999-9999"
}

export const TEXTAREA = {
  MAX: 5,
  MIN: 3
};

export const MAX_INTEGER = 2147483647;
export const SEPARATOR = " — ";

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const TWO_WAY_SECRET = process.env.REACT_APP_TWO_WAY_SECRET; // use a 32-char string for AES-256
export const HASHING_SECRET = process.env.REACT_APP_HASHING_SECRET; // use a 32-char string for AES-256

export const S3 = {
  ENDPOINT: process.env.REACT_APP_S3_ENDPOINT,
  REGION: process.env.REACT_APP_S3_REGION,
  ACCESS_KEY: process.env.REACT_APP_S3_ACCESS_KEY,
  SECRET_KEY: process.env.REACT_APP_S3_SECRET_KEY,
  BUCKET_NAME: process.env.REACT_APP_S3_BUCKET_NAME,
}